import { useState, useEffect } from 'react';
import { wishlistAPI } from '../api/services';
import Loading from '../components/common/Loading';
import { Link } from 'react-router-dom';
import { FiTrash2, FiShoppingCart, FiHeart } from 'react-icons/fi';
import toast from 'react-hot-toast';
import './Wishlist.css';

export default function Wishlist() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    wishlistAPI.get().then(res => setItems(res.data.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const handleRemove = async (productId) => {
    try {
      await wishlistAPI.remove(productId);
      setItems(prev => prev.filter(i => i.productId !== productId));
      toast.success('Removed from wishlist');
    } catch (err) {
      toast.error('Failed to remove');
    }
  };

  const handleAddToCart = (item) => {
    toast('Please select variant on the product page');
  };

  if (loading) return <Loading />;

  if (items.length === 0) {
    return (
      <div className="empty-state">
        <FiHeart size={48} />
        <h2>Your wishlist is empty</h2>
        <p>Save items you love to buy later.</p>
        <Link to="/shop" className="btn btn-primary">Browse Products</Link>
      </div>
    );
  }

  return (
    <div className="wishlist-page">
      <h1>My Wishlist ({items.length})</h1>
      <div className="wishlist-grid">
        {items.map(item => (
          <div key={item.id} className="wl-card">
            <Link to={`/product/${item.productSlug}`} className="wl-image">
              {item.productImage ? <img src={item.productImage} alt={item.productName} /> : <div className="wl-no-img">No Image</div>}
            </Link>
            <div className="wl-info">
              <Link to={`/product/${item.productSlug}`} className="wl-name">{item.productName}</Link>
              <p className="wl-price">₹{item.salePrice || item.price}</p>
            </div>
            <div className="wl-actions">
              <button className="btn btn-primary btn-sm" onClick={() => handleAddToCart(item)}>
                <FiShoppingCart /> Add to Cart
              </button>
              <button className="btn btn-outline btn-icon-sm" onClick={() => handleRemove(item.productId)}>
                <FiTrash2 />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
